import { useEffect } from 'react';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { CheckboxField, FormFieldProps } from '@brighte/form-components';
import { Address } from './AddressFields';

type AddressWithSameAsCheckboxProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  sourceAddress: any;
  formContext: FormFieldProps<TFieldValues>;
  fieldLabel: string;
  checkboxLabel: string;
  checkboxName: Path<TFieldValues>;
  isJointApplicant?: boolean;
};

function AddressWithSameAsCheckbox<TFieldValues extends FieldValues = FieldValues>({
  name,
  sourceAddress,
  formContext,
  fieldLabel,
  checkboxLabel,
  checkboxName,
}: Readonly<AddressWithSameAsCheckboxProps<TFieldValues>>) {
  const { setValue, control, watch } = formContext as UseFormReturn;

  const checked = watch(checkboxName);

  const { fullAddress, unitNumber, streetNumber, streetName, suburb, state, postcode } = sourceAddress ?? {};

  useEffect(() => {
    if (checked) {
      setValue(name, sourceAddress);
    }
  }, [fullAddress, unitNumber, streetNumber, streetName, suburb, state, postcode, checked]);

  const handleChange = () => {
    if (checked) {
      setValue(name, undefined as any);
    }
  };

  return (
    <>
      <Address
        label={fieldLabel}
        name={name}
        setValue={setValue}
        control={control}
        disabled={checked}
        defaultValue={checked ? sourceAddress : null}
      />
      <CheckboxField name={checkboxName} control={control} label={checkboxLabel} onChange={handleChange} />
    </>
  );
}

export { AddressWithSameAsCheckbox };
